import React from 'react';
import AutoText from '../../atoms/text/auto';
import Card from '../card';
import { IContact } from '../../../libs/contact';
import cc from 'classcat';
import Button from '../../molecules/button';

interface ContactCardProps {
  contact: IContact;
  isSelected?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const ContactCard: React.FC<ContactCardProps> = ({
  contact,
  onClick,
  isSelected = false
}) => {
  const description = contact.description
    ? contact.description
    : 'No description.';
  const classes = cc([
    'pa-4',
    isSelected ? 'bg-light-green border-green' : undefined
  ]);
  return (
    <Button
      data-contact-id={contact.id}
      bare
      variant="minimal"
      fill
      onClick={onClick}
      className="pa-0-important btn-text-wide mb-4"
    >
      <Card interactive className={classes}>
        <ul className="list-none pl-0 ma-0">
          <li className="font-bold mb-4">{contact.displayName}</li>
          <li className="mb-4">
            <i>
              <AutoText ellipsize={true}>{contact.email}</AutoText>
            </i>
          </li>
          <li>
            <AutoText ellipsize={true}>{description}</AutoText>
          </li>
        </ul>
      </Card>
    </Button>
  );
};

export default ContactCard;
